import { CommonResponse, StockItemCategoryModelDto, StockItemCategoryResponseModel } from "@gtpl/shared-models/masters";
import connection from "./connection";
import axios from "axios";

export class StockItemCategoryServices{
  
    URL = connection.DEPLOY_URL + '/stock-item-categories';

    async UploadExcel(req:StockItemCategoryModelDto): Promise<StockItemCategoryResponseModel> {
        return await axios.post(this.URL + '/StockItemCategoryService',req)
            .then(res => {
                return res.data
            })
    }

    async getStockItem(): Promise<StockItemCategoryResponseModel> {
        return await axios.post(this.URL + "/getStockItem")
        .then(res => {
            return res.data
          })
    }

    async getVendorCategories(): Promise<StockItemCategoryResponseModel> {
        return await axios.post(this.URL + "/getVendorCategories")
        .then(res => {
            return res.data
          })
    }

    async getEndCustomerCategories(): Promise<StockItemCategoryResponseModel> {
        return await axios.post(this.URL + "/getEndCustomerCategories")
        .then(res => {
            return res.data
          })
    }

    async getStockItemCategories(): Promise<StockItemCategoryResponseModel> {
        return await axios.post(this.URL + "/getStockItemCategories")
        .then(res => {
            return res.data
          })
    }
}